import React from "react";
import { withTranslation } from "react-i18next";
import "./StaffTracking.scss";
import { staffTrackingStatusOptions } from "constants";

export const staffTrackingPolicyStatus = staffTrackingStatusOptions;

export const STAFF_TRACKING_PENDING_STATUS_ID =
  staffTrackingStatusOptions.find((status) => status.name === "Pending")?.id ?? 2;

function StaffTrackingPolicyStatus({
   setSelectedValues,
   selectedValues = [],
   t,
}) {

  const handleChange = (e, item) => {
    const offices = [...selectedValues];

    const oIndex = offices.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      offices.push(item.id);
    } else {
      if (oIndex > -1) offices.splice(oIndex, 1);
    }
    setSelectedValues(offices);
  };

  return (
    <ul className={["filter-list"]}>
      {staffTrackingPolicyStatus.map((item) => (
          <li key={item.uniqueKey}>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) => handleChange(e, item)}
                  checked={selectedValues?.includes(item.id)}
                />{" "}
                <span> {item.name}</span>
              </label>
            </div>
          </li>
        ))}
    </ul>
  );
}

export default withTranslation()(StaffTrackingPolicyStatus);
